import styled from 'styled-components'

export const Style = styled.div`

    
    
    .class-example{
        color: red;
    }

    .case-main-image{
        margin: 18% 0 0 0;
        max-width: 206px;
    }

    .clinical-case-title-container{
        margin: 10% 40px 0 40px;
    }

    .clinical-case-title{
        text-align: center;
        font: normal normal bold 30px/54px Montserrat;
        line-height: 32px;
        letter-spacing: 0px;
        color: #171717;
        opacity: 1;
    }

    .clinical-case-subtitle-container{
        margin: 10% 40px 0 40px;
    }

    .clinical-case-subtitle{
        text-align: center;
        font: normal normal bold 20px/26px Montserrat;
        letter-spacing: 0px;
        color: #171717;
        opacity: 1;
    }

    .clinical-case-code-container{
        margin: 6% 40px 0 40px;
    }

    .clinical-case-code{
        text-align: center;
        font: normal normal bold 16px/36px Montserrat;
        letter-spacing: 0px;
        color: #6C6C6C;
        opacity: 1;
    }

    .clinical-case-description-container{
        margin: 10% 40px 0 40px;
    }

    .clinical-case-description{
        text-align: left;
        font: normal normal 300 16px/20px Montserrat;
        letter-spacing: 0px;
        color: #171717;
        opacity: 1;
    }

    .gallery-container{
        background: #1E1E1E 0% 0% no-repeat padding-box;
        opacity: 1;
        margin: 6% 0 0 0;
    }

    .gallery-display{
        margin: 6% 0 0 0;
    }

    .gallery-img{
        width: 90%;
        margin: 0 5% 25px 5%;
        border-radius: 22px;
    }

    .learn-more-button{
        background: #7160FF 0% 0% no-repeat padding-box;
        opacity: 1;
        text-align: left;
        font: normal normal bold 16px/25px Montserrat;
        letter-spacing: 0px;
        color: #FFFFFF;
        opacity: 1;
        border-radius: 45px;
        margin: 40% 0 40% 0;
    }


    .default-button {
        font-family: 'Montserrat',sans-serif;
        font: normal normal bold 16px/18px Montserrat;
        
        display: flex;
        text-align: center;
        border-radius: 35px;
        align-items: center;
        justify-content: center;
        align-content: center;
        border: none;
        background: #7160ff;
        width: 293px;
        height:69px;
        margin-top:100px;
    }
    .clear{
        margin-top: 100px;
    }


    .footer{
        margin: 5% 0 3% 0;
    }

    .nav-footer-button{
        background: transparent;
        text-align: left;
        font: normal normal medium 14px/36px Montserrat ;
        letter-spacing: 0px;
        color: #1E1E1E;
        opacity: 1;
        font-weight: 550;

    }

    .arrow {
        border: solid black;
        border-width: 0 3px 3px 0;
        display: inline-block;
        padding: 3px;
      }
      
      .right {
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
      }
      
      .left {
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
      }
      
`;